module.exports = __webpack_public_path__ + "static/img/sm3.fa20de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm3.jpg
// module id = FG2T
// module chunks = 1